import { FC } from 'react';
import HamburgerMenuIcon from 'images/hamburger-menu.svg';
import { Image } from 'components/HamburgerMenu/style';

export interface HamburgerMenuProps {
  onClick: () => void;
  width: string;
  height: string;
}

const HamburgerMenu: FC<HamburgerMenuProps> = ({
  width,
  height,
  onClick,
  ...props
}) => {
  return (
    <Image
      onClick={onClick}
      src={HamburgerMenuIcon}
      width={width}
      height={height}
      alt="hamburger-menu"
      {...props}
    />
  );
};

export default HamburgerMenu;
